<template>
    <div>
        <input :id="id" :type="type" :value="value" @input="change"
        class="form-control" :class="{'input-error' : isError}" :name="name" required :autofocus="autofocus" @blur="isError = false">
        <span v-if="isError" class="error">{{error}}</span>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                isError: this.error ? true : false
            }
        },
        props: {
            error: {
                type: String,
                default: ''
            },
            id: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: 'text'
            },
            name: {
                type: String,
                default: ''
            },
            autofocus: {
                type: Boolean,
                default: false
            },
            value: {
                type: String,
                default: ''
            },
        },
        methods: {
            change(){
                this.isError = false
            }
        }
    }

</script>
<style lang="scss" scoped>
    .error{
        padding: 15px;
        border-radius: 4px;
        background-color: #ff6665;
        font-weight: 400;
        font-size: 14px !important;
        line-height: 19px !important;
        letter-spacing: 0.02em;
        color: #000000;
        color: #fff;
        width: -webkit-fit-content;
        width: -moz-fit-content;
        width: fit-content;
        position: absolute;
        right: 0;
        z-index: 100;
        top: 45px;
        bottom: auto !important;
        &::before{
            content: "";
            position: absolute;
            right: 9px;
            top: -3px;
            width: 0.7em;
            height: 0.7em;
            background: linear-gradient(to bottom left, #ff6665 50%, transparent 50%);
            border-radius: 0.2em;
            transform: rotate(-45deg);
        }
    }
</style>